import classNames from "classnames";
import React from "react";
import { CSSTransition } from "react-transition-group";
import slidingMenuStyles from "./SlidingMenu.module.scss";
import animationStyles from "./animationStyles.module.scss";
import { ClickAway } from "@netapp/bxp-design-system-react";

const slideInClassNames = {
    enter: animationStyles['enter'],
    enterActive: animationStyles['enter-active'],
    exit: animationStyles['exit'],
    exitActive: animationStyles['exit-active']
};

const slideInFromLeftClassNames = {
    enter: animationStyles['enter-from-left'],
    enterActive: animationStyles['enter-from-left-active'],
    exit: animationStyles['exit-from-left'],
    exitActive: animationStyles['exit-from-left-active']
};

export default ({ children, isActive, closeTrigger, className, top, maskClassName, isSlidingFromLeft = false }) => {
    const nodeRef = React.useRef(null);
    return <>
        <CSSTransition nodeRef={nodeRef} classNames={isSlidingFromLeft ? slideInFromLeftClassNames : slideInClassNames} in={isActive} unmountOnExit timeout={400}>
            <div ref={nodeRef} className={classNames(className, isSlidingFromLeft ? slidingMenuStyles["menu-sliding-from-left"] : slidingMenuStyles["menu-sliding-from-right"])} style={{top}}>
                <>
                    { isActive && <ClickAway ignoreParentClick={true} listener = {(e) => {
                        closeTrigger(e);
                    }}/> }
                    {children}
                </>
            </div>
        </CSSTransition>
        {isActive && <div className={classNames(slidingMenuStyles['sliding-menu-mask'], maskClassName)} style={{top}}/>}
    </>
};